import commonActions from "../common/actions";
import authActions from "./actions";
import axios from "axios";
import { takeEvery, call, all, put, delay, select } from "redux-saga/effects";
import { API_URL } from "../../utils/constants";
import Cookies from "js-cookie";
import setAuthToken from "../../utils/setAuthToken";
import {
  handleDecodeJSON,
  handleEncodeJson,
} from "../../utils/encodeDecodeJson";
import examActions from "../exam/actions";
const { ipcRenderer } = window.require
  ? window.require("electron")
  : { ipcRenderer: null };

const authSagas = function* () {
  yield all([yield takeEvery(authActions.CANDIDATE_LOGIN, candidateLogin)]);
};

const candidateLogin = function* (data) {
  const { payload } = data;
  const { navigate, setError, mockMode, url } = payload;

  try {
    let result;
    if (mockMode) {
      result = yield call(() =>
        axios.post(
          `${url || API_URL}/api/exam/mock-candidate-login`,
          payload.data
        )
      );
    } else {
      result = yield call(() =>
        axios.post(`${API_URL}/api/exam/candidate-login`, payload.data)
      );
    }

    const encodedResult = JSON.stringify(result?.data?.data);
    const decodedResult = yield call(() =>
      handleDecodeJSON({ decodeJSON: result?.data?.data })
    );

    if (result?.data?.code === "OK") {
      const heartBeat = yield select((state) => state.examReducer.heartBeat);
      const data = {
        auditLog: [
          {
            RegistrationNumber: `${decodedResult?.user?.id}`,
            RollNumber: `${decodedResult?.user?.rollNo}`,
            Activity: "User Logged in",
            Timestamp: `${heartBeat?.date}`,
            IPaddress: "",
          },
        ],
      };
      yield put({ type: examActions.AUDIT_LOG, payload: { data: data } });
      localStorage.setItem(
        "examEndTime",
        decodedResult?.configuration?.endTime
      );
      const venue = sessionStorage.getItem("venue");
      if (venue && ipcRenderer) {
        try {
          ipcRenderer.send("run-python-script");
        } catch (err) {
          console.log(err);
        }
      }
      if (!decodedResult?.configuration?.forcedLogout && !mockMode) {
        const adjustedCurrentTimestamp = new Date(
          Date.now() + (5 * 60 + 30) * 60 * 1000
        );
        const formattedCurrentTimestamp = adjustedCurrentTimestamp
          .toISOString()
          .replace(/\.\d{3}/, "");
        const convertToMinutes = (timeStr) => {
          const [hours, minutes] = timeStr.split(":").map(Number);
          return hours * 60 + minutes;
        };
        const timeDuration = convertToMinutes(
          decodedResult?.configuration?.timeDuration
        );

        if (decodedResult?.configuration?.startExamBetweenSpecifiedTime) {
          if (decodedResult?.user?.loginTime) {
            const timeDuration = decodedResult?.configuration?.timeDuration;
            const sections = decodedResult?.configuration?.sections;
            const timeToMinutes = (time) => {
              const [hh, mm] = time.split(":").map(Number);
              return hh * 60 + mm;
            };
            const minutesToTime = (minutes) => {
              const hh = Math.floor(minutes / 60)
                .toString()
                .padStart(2, "0");
              const mm = (minutes % 60).toString().padStart(2, "0");
              return `${hh}:${mm}`;
            };
            const totalTimeAllocated = sections.reduce(
              (sum, sec) => sum + timeToMinutes(sec.sectionTime),
              0
            );
            const totalAllowedTime = timeToMinutes(timeDuration);
            let timeDiff = totalTimeAllocated - totalAllowedTime;
            for (let i = 0; i < sections.length && timeDiff > 0; i++) {
              let sectionMinutes = timeToMinutes(sections[i].sectionTime);

              if (sectionMinutes > 0) {
                const reduceBy = Math.min(timeDiff, sectionMinutes);
                sectionMinutes -= reduceBy;
                sections[i].sectionTime = minutesToTime(sectionMinutes);
                timeDiff -= reduceBy;
              }
            }
            decodedResult.configuration.sections = sections;
          }

          const currentDate = new Date(formattedCurrentTimestamp);
          decodedResult.configuration.startTime = currentDate;
          const newEndTime = new Date(
            currentDate.getTime() + timeDuration * 60 * 1000
          );
          decodedResult.configuration.endTime = newEndTime.toISOString();

          if (decodedResult?.user?.scribeRequired) {
            const totalMinutes = decodedResult?.configuration?.sections.reduce(
              (total, section) => {
                const [hours, minutes] = section.sectionTime
                  .split(":")
                  .map(Number);
                return total + (hours * 60 + minutes);
              },
              0
            );

            const [scribeHours, scribeMinutes] =
              decodedResult.configuration?.timeDurationForScribe
                .split(":")
                .map(Number);
            const timeDurationForScribeInMinutes =
              scribeHours * 60 + scribeMinutes;

            if (totalMinutes === timeDurationForScribeInMinutes) {
              let newEndTime = new Date(
                currentDate.getTime() + totalMinutes * 60 * 1000
              );
              decodedResult.configuration.endTime = newEndTime.toISOString();
            } else {
              const differenceInMinutes =
                timeDurationForScribeInMinutes - totalMinutes;
              const sections = decodedResult.configuration.sections;
              const extraPerSection = Math.floor(
                differenceInMinutes / sections.length
              );
              const remainder = differenceInMinutes % sections.length;

              sections.forEach((section, index) => {
                let [hours, minutes] = section.sectionTime
                  .split(":")
                  .map(Number);
                let extraMinutes =
                  extraPerSection + (index < remainder ? 1 : 0);
                let totalSectionMinutes = hours * 60 + minutes + extraMinutes;
                let newHours = Math.floor(totalSectionMinutes / 60);
                let newMinutes = totalSectionMinutes % 60;
                section.sectionTime = `${String(newHours).padStart(
                  2,
                  "0"
                )}:${String(newMinutes).padStart(2, "0")}`;
              });

              const newTotalMinutes = sections.reduce((total, section) => {
                const [h, m] = section.sectionTime.split(":").map(Number);
                return total + h * 60 + m;
              }, 0);

              let newEndTime = new Date(
                currentDate.getTime() + newTotalMinutes * 60 * 1000
              );
              decodedResult.configuration.endTime = newEndTime.toISOString();
            }
          }
        }

        const updatedEncodedResult = { ...decodedResult };
        const encodedResponse = yield call(() =>
          handleEncodeJson({ encodeJSON: updatedEncodedResult })
        );
        Cookies.set("test_engine_token", decodedResult?.token?.accessToken, {
          expires: 7,
        });
        setAuthToken(decodedResult?.token?.accessToken);
        sessionStorage.setItem(
          "candidate_exam_details",
          JSON.stringify(encodedResponse)
        );
        sessionStorage.setItem(
          "candidate_details",
          JSON.stringify(decodedResult?.user || decodedResult?.candidate)
        );
      } else {
        if (decodedResult?.user?.scribeRequired) {
          const totalMinutes = decodedResult?.configuration?.sections.reduce(
            (total, section) => {
              const [hours, minutes] = section.sectionTime
                .split(":")
                .map(Number);
              return total + (hours * 60 + minutes);
            },
            0
          );

          const [scribeHours, scribeMinutes] =
            decodedResult.configuration?.timeDurationForScribe
              .split(":")
              .map(Number);
          const timeDurationForScribeInMinutes =
            scribeHours * 60 + scribeMinutes;

          if (totalMinutes != timeDurationForScribeInMinutes) {
            const differenceInMinutes =
              timeDurationForScribeInMinutes - totalMinutes;
            const sections = decodedResult.configuration.sections;
            const extraPerSection = Math.floor(
              differenceInMinutes / sections.length
            );
            const remainder = differenceInMinutes % sections.length;

            sections.forEach((section, index) => {
              let [hours, minutes] = section.sectionTime.split(":").map(Number);
              let extraMinutes = extraPerSection + (index < remainder ? 1 : 0);
              let totalSectionMinutes = hours * 60 + minutes + extraMinutes;
              let newHours = Math.floor(totalSectionMinutes / 60);
              let newMinutes = totalSectionMinutes % 60;
              section.sectionTime = `${String(newHours).padStart(
                2,
                "0"
              )}:${String(newMinutes).padStart(2, "0")}`;
            });
            decodedResult.configuration.sections = sections;
            const updatedEncodedResult = { ...decodedResult };
            const encodedResponse = yield call(() =>
              handleEncodeJson({ encodeJSON: updatedEncodedResult })
            );
            Cookies.set(
              "test_engine_token",
              decodedResult?.token?.accessToken,
              { expires: 7 }
            );
            sessionStorage.setItem(
              "candidate_details",
              JSON.stringify(decodedResult?.user || decodedResult?.candidate)
            );
            setAuthToken(decodedResult?.token?.accessToken);
            sessionStorage.setItem(
              "candidate_exam_details",
              JSON.stringify(encodedResponse)
            );
          }
        } else {
          Cookies.set("test_engine_token", decodedResult?.token?.accessToken, {
            expires: 7,
          });
          sessionStorage.setItem(
            "candidate_details",
            JSON.stringify(decodedResult?.user || decodedResult?.candidate)
          );
          setAuthToken(decodedResult?.token?.accessToken);
          sessionStorage.setItem("candidate_exam_details", encodedResult);
        }
      }

      if (mockMode) {
        navigate(`/home`);
        window.location.reload();
      } else {
        navigate(`/${Cookies.get("test_engine_project")}/home`);
      }

      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
      }

      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: "success",
          show: true,
          message: "Login Successfully",
        },
      });
    } else {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: "failed",
          show: true,
          message: "Username or Password Wrong",
        },
      });
    }

    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } catch (err) {
    if (err?.response?.data?.code === "E_NOT_FOUND") {
      setError("password", {
        type: "manual",
        message: "Username or Password Wrong",
      });
    }
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: "failed",
        show: true,
        message:
          err?.response?.data?.code === "EXAM_NOT_STARTED"
            ? "You can login only after the permitted login time"
            : err?.response?.data?.code === "LOGIN_TIME_EXPIRES"
            ? "Your Exam Login Time Has Ended"
            : err?.response?.data?.code === "E_NOT_FOUND"
            ? "Username or Password Wrong"
            : err?.response?.data?.code === "MAXIMUM_LOGIN_ATTEMPTS_EXCEEDED"
            ? "Maximum login attempts exceeded"
            : err?.response?.data?.code === "UNPROCESSABLE_ENTITY"
            ? "User is already logged in"
            : "The Exam Has Ended or Could Not Be Found",
      },
    });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
    console.log(err);
  }
};

export default authSagas;
